import i18n from "i18n";

const Messages = {
  Update: i18n.t('notifications.common.update', { dataType: i18n.t('labels.companyAccount') })
};

export default Messages;

i18n.on('languageChanged', () => {
  Messages.Update = i18n.t('notifications.common.update', { dataType: i18n.t('labels.companyAccount') });
});